import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Import des styles
import './assets/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// En production, on expose une méthode d'initialisation
if (import.meta.env.PROD) {
    window.ZebuMemberArea = {
        initZebuMemberArea: () => {
            app.mount('#app')
        }
    }
    // Auto-init après que le DOM soit chargé
    document.addEventListener('DOMContentLoaded', () => {
        if (document.getElementById('app')) {
            window.ZebuMemberArea.initZebuMemberArea()
        }
    })
} else {
    // En développement, on monte directement sur #app
    app.mount('#app')
} 